import script from "./SetupRemindersContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./SetupRemindersContent.vue?vue&type=script&lang=ts&setup=true"

import "./SetupRemindersContent.vue?vue&type=style&index=0&id=3030e567&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3030e567"]])

export default __exports__